/* eslint-disable no-lone-blocks */
/**
 * @file 核心优势
 * @author wanzhongyun
 */

import { RootObject, CoreStrengthsModule, ContentList } from '../../type';


import './style.less';

const CoreStrengths = (props: RootObject["coreStrengths"]) => {
  return (
    <div className="co-creation-core-strengths">
      <div className="co-creation-core-strengths-title">
        {
          props.coreStrengthsTitle ?? ""
        }
      </div>
      <div className="co-creation-core-strengths-content">

        {
          props.coreStrengthsModule.map((value: CoreStrengthsModule, index: number) => {

            return (
              <div className="co-creation-core-strengths-content-module" key={index}>

                <div className="active-module">
                  <div className="active-module-img" style={{ background: `url(${value.partnerList})` }}></div>
                  <div className="active-module-title">
                    {
                      value.imgName ?? ""
                    }
                  </div>
                </div >
                <div className="hidden-module">
                  <div className="hidden-module-title">
                    {
                      value.title ?? ""
                    }
                  </div>
                  <div className="hidden-module-list-desc">
                    {
                      value.contentList.map((describe: ContentList, keyIndex) => {
                        return (<div className="list-desc" key={keyIndex}>
                          <span className="list-desc-round"></span>{describe.title ?? ""}
                        </div>)
                      })
                    }
                  </div>
                </div>
              </div>
            )
          })
        }

      </div>
    </div>
  )
}

export default CoreStrengths